import { Component, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  BaseIdDirective,
  ChildIdDirective,
  CoreUiModule,
  getLoadedValueOrNull,
  trackLoadingSwitchMap,
} from 'webcommon/core-ui';
import { generateHtmlId, GenericSimpleChanges, GuidStrValue, ServerFeature, SessionRequest_Create } from 'webcommon/shared';
import { TerminologyRepository } from 'webcommon/webapi';
import { ServerInfoRepository } from 'webcommon/legacy-common';

const nextId = generateHtmlId('ap-terminology-search');

@Component({
  selector: 'ap-terminology-search',
  standalone: true,
  imports: [CoreUiModule, ChildIdDirective],
  templateUrl: './terminology-search.component.html',
  styleUrls: ['./terminology-search.component.less'],
  host: {
    /* eslint-disable quote-props */
    'class': 'flex-col',
  },
  hostDirectives: [
    BaseIdDirective,
  ],
})
export class TerminologySearchComponent implements OnChanges {
  static readonly ajsComponentName = 'apTerminologySearch';

  @Input() sessionRequest: SessionRequest_Create;
  @Output() sessionTokenChange = new EventEmitter<GuidStrValue | undefined>();

  createSession$ = new ReplaySubject<SessionRequest_Create>(1);
  sessionResponse$ = this.createSession$.pipe(
    trackLoadingSwitchMap((sessionRequest) => {
      return this.terminologyRepository.createSession(sessionRequest);
    }),
    tap((sessionResponse) => {
      const currentSessionToken = getLoadedValueOrNull(sessionResponse)?.value.SessionToken;
      this.sessionTokenChange.emit(currentSessionToken);
    }),
  );

  static isSupportedFn(): () => boolean {
    const serverInfoRepository = inject(ServerInfoRepository);
    return () => {
      return serverInfoRepository.isSupported(
        ServerFeature.Terminology_Sessions,
        ServerFeature.Terminology_IMOSearch,
      );
    };
  }

  constructor(
    private terminologyRepository: TerminologyRepository,
  ) {
    BaseIdDirective.setupAsHostDirective(nextId);
  }

  ngOnChanges(changes: GenericSimpleChanges<TerminologySearchComponent>) {
    if (changes.sessionRequest?.currentValue) {
      this.createSession$.next(changes.sessionRequest.currentValue);
    }
  }
}
